

export const DIALOG_TYPE = 'DIALOG_WEBFIRST_ADDITIONAL_DESKTOP_FEATURES';
